module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('a', {
    attrs: {
      "id": "title41"
    }
  }, [_c('p', {
    staticClass: "p-c"
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "p-c"
  }, [_vm._v("To my close family, without whose encouragement and support I would not have the time to embark upon projects such as these. Thanks to them for making sure that other areas of my life keep going.")]), _vm._v(" "), _c('p', {
    staticClass: "p-c"
  }, [_vm._v("Also to Shaun and Zara for their unfailing support every time ‘Chris’ writes another one! Love to you both.")]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-c"
  }, [_vm._v("Oh, and thanks to my wife for the title!")]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "p-c"
  }, [_vm._v(". . . by the way, Dave – surely this time!")])])]), _c('a', {
    attrs: {
      "id": "title41"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d60ec6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783408566_ded01.vue
// module id = 72
// module chunks = 0